import { create } from "zustand";

export const useLanguageStore = create((set) => ({
  language: localStorage.getItem("language") || "hr-HR", // Default language is Croatian
  setLanguage: (lang) => set({ language: lang }),
}));
